module.exports = __webpack_public_path__ + "media/categories/7021-a615be71.svg";